import { LoadingState } from "../domain/data-layer/loading-state";
import { SwarovskiOptikLocaleFrontend, SwarovskiPageData, SwarovskiPageDataFrontend } from "@swo/storefront";
import { useEqualState } from "../hooks";
import { SwarovskiOptikSegmentShort } from "@swo/shared";
import { useEffect } from "react";

export function useLastLocaleSegmentPair(lastPageLs: { data: LoadingState<SwarovskiPageDataFrontend> }) {
  const [state, setState] = useEqualState<
    { locale: SwarovskiOptikLocaleFrontend; segment: SwarovskiOptikSegmentShort } | undefined
  >(readFromLs(lastPageLs));

  function readFromLs(lsd: {
    data: LoadingState<SwarovskiPageDataFrontend>;
  }): { locale: SwarovskiOptikLocaleFrontend; segment: SwarovskiOptikSegmentShort } | undefined {
    if (lsd.data.__tag === "loaded") {
      const {
        data: { locale, segment },
      } = lsd.data;

      return {
        locale,
        segment,
      };
    } else {
      return undefined;
    }
  }

  useEffect(() => {
    const maybeNewData = readFromLs(lastPageLs);

    if (maybeNewData) {
      setState(maybeNewData);
    }
  }, [lastPageLs]);

  return state;
}
